import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTemplateAdminAreaMeta, LazyTemplateAdminArea, LazyTemplateAdminAreaOurUsersMeta, LazyTemplateAdminAreaOurUsers, LazyTemplateBasket, LazyTemplateCheckout, LazyTemplateCheckoutResult, LazyTemplateHome, LazyTemplateLoginMeta, LazyTemplateLogin, LazyTemplateMyAccountMeta, LazyTemplateMyAccount, LazyTemplateMyAccountMyDetailsMeta, LazyTemplateMyAccountMyDetails, LazyTemplateMyAccountOurOrdersMeta, LazyTemplateMyAccountOurOrders, LazyTemplateMyAccountOurQuotesMeta, LazyTemplateMyAccountOurQuotes, LazyTemplateMyAccountOurWishlistsMeta, LazyTemplateMyAccountOurWishlists, LazyTemplateMyAccountSubscriptionsMeta, LazyTemplateMyAccountSubscriptions, LazyTemplatePasswordReset, LazyTemplateProduct, LazyTemplateProductTheme, LazyTemplateProductThemesArea, LazyTemplateProductsArea, LazyTemplateRegistration, LazyTemplateSearch, LazyTemplateTestimonialsArea, LazyTemplateWishlist, LazyBlockPaymentCheckbox, LazyContentGridControlsControlApolloGridAccordionEditor, LazyContentGridControlsControlApolloGridCarouselEditor, LazyContentGridControlsControlApolloGridCopyEditor, LazyContentGridControlsControlApolloGridHeadingEditor, LazyContentGridControlsControlApolloGridQuoteEditor, LazyContentGridControlsControlApolloGridRichTextEditor, LazyContentGridControlsControlHeadline, LazyContentGridControlsControlMedia, LazyContentGridControlsControlQuote, LazyContentGridControlsControlRte } from '#components'
const lazyGlobalComponents = [
  ["TemplateAdminAreaMeta", LazyTemplateAdminAreaMeta],
["TemplateAdminArea", LazyTemplateAdminArea],
["TemplateAdminAreaOurUsersMeta", LazyTemplateAdminAreaOurUsersMeta],
["TemplateAdminAreaOurUsers", LazyTemplateAdminAreaOurUsers],
["TemplateBasket", LazyTemplateBasket],
["TemplateCheckout", LazyTemplateCheckout],
["TemplateCheckoutResult", LazyTemplateCheckoutResult],
["TemplateHome", LazyTemplateHome],
["TemplateLoginMeta", LazyTemplateLoginMeta],
["TemplateLogin", LazyTemplateLogin],
["TemplateMyAccountMeta", LazyTemplateMyAccountMeta],
["TemplateMyAccount", LazyTemplateMyAccount],
["TemplateMyAccountMyDetailsMeta", LazyTemplateMyAccountMyDetailsMeta],
["TemplateMyAccountMyDetails", LazyTemplateMyAccountMyDetails],
["TemplateMyAccountOurOrdersMeta", LazyTemplateMyAccountOurOrdersMeta],
["TemplateMyAccountOurOrders", LazyTemplateMyAccountOurOrders],
["TemplateMyAccountOurQuotesMeta", LazyTemplateMyAccountOurQuotesMeta],
["TemplateMyAccountOurQuotes", LazyTemplateMyAccountOurQuotes],
["TemplateMyAccountOurWishlistsMeta", LazyTemplateMyAccountOurWishlistsMeta],
["TemplateMyAccountOurWishlists", LazyTemplateMyAccountOurWishlists],
["TemplateMyAccountSubscriptionsMeta", LazyTemplateMyAccountSubscriptionsMeta],
["TemplateMyAccountSubscriptions", LazyTemplateMyAccountSubscriptions],
["TemplatePasswordReset", LazyTemplatePasswordReset],
["TemplateProduct", LazyTemplateProduct],
["TemplateProductTheme", LazyTemplateProductTheme],
["TemplateProductThemesArea", LazyTemplateProductThemesArea],
["TemplateProductsArea", LazyTemplateProductsArea],
["TemplateRegistration", LazyTemplateRegistration],
["TemplateSearch", LazyTemplateSearch],
["TemplateTestimonialsArea", LazyTemplateTestimonialsArea],
["TemplateWishlist", LazyTemplateWishlist],
["BlockPaymentCheckbox", LazyBlockPaymentCheckbox],
["ContentGridControlsControlApolloGridAccordionEditor", LazyContentGridControlsControlApolloGridAccordionEditor],
["ContentGridControlsControlApolloGridCarouselEditor", LazyContentGridControlsControlApolloGridCarouselEditor],
["ContentGridControlsControlApolloGridCopyEditor", LazyContentGridControlsControlApolloGridCopyEditor],
["ContentGridControlsControlApolloGridHeadingEditor", LazyContentGridControlsControlApolloGridHeadingEditor],
["ContentGridControlsControlApolloGridQuoteEditor", LazyContentGridControlsControlApolloGridQuoteEditor],
["ContentGridControlsControlApolloGridRichTextEditor", LazyContentGridControlsControlApolloGridRichTextEditor],
["ContentGridControlsControlHeadline", LazyContentGridControlsControlHeadline],
["ContentGridControlsControlMedia", LazyContentGridControlsControlMedia],
["ContentGridControlsControlQuote", LazyContentGridControlsControlQuote],
["ContentGridControlsControlRte", LazyContentGridControlsControlRte],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
